import { parseNarrative } from "@hamlak/shared";
import { useMemo } from "react";
import styles from "./CharacterMessage.module.css";
import { cx } from "../cx";
import { NarrativeBlocks } from "./NarrativeBlocks";

/**
 * 마크다운 본문(채팅 메시지와 같은 파서·모양). 소개·첫 장면 text 블록, 어드민 미리보기용.
 * plain 이면 기호 없는 문단을 말풍선 대신 일반 문단으로, mine 이면 내 메시지(오른쪽, 대사는 내 말풍선)로 그린다.
 */
export function MarkdownBody({ text, plain = false, mine = false, className }: { text: string; plain?: boolean; mine?: boolean; className?: string }) {
  const blocks = useMemo(() => parseNarrative(text), [text]);
  if (blocks.length === 0) return null;
  return (
    <div className={cx(styles.body, className)}>
      <NarrativeBlocks blocks={blocks} plain={plain} mine={mine} />
    </div>
  );
}
